import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=fbc13076&scoped=true"
import script from "./ShopItem.vue?vue&type=script&lang=js"
export * from "./ShopItem.vue?vue&type=script&lang=js"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=fbc13076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc13076",
  null
  
)

export default component.exports